import { describeApiError, recordApiError } from "./apiErrorDetail";
import ky, { type KyInstance } from "ky";
import { useAuthStore } from "../store/auth";

export const BASE =
  import.meta.env.VITE_API_BASE_URL ??
  (import.meta.env.PROD ? "https://kkks-admin-app.vercel.app" : "http://localhost:3000");

let _client: KyInstance | null = null;

async function refreshTokens(): Promise<string | null> {
  const { refreshToken, setTokens, logout } = useAuthStore.getState();
  if (!refreshToken) return null;  // store not yet hydrated — don't logout
  try {
    const res = await ky.post(`${BASE}/api/v1/auth/refresh`, {
      json: { refreshToken },
    }).json<{ data: { accessToken: string; refreshToken: string } }>();
    setTokens(res.data.accessToken, res.data.refreshToken);
    return res.data.accessToken;
  } catch {
    logout();
    return null;
  }
}

export function getClient(): KyInstance {
  if (_client) return _client;
  _client = ky.create({
    prefixUrl: `${BASE}/api/v1`,
    timeout: 30_000,
    hooks: {
      beforeRequest: [
        (req) => {
          const token = useAuthStore.getState().accessToken;
          if (token) req.headers.set("Authorization", `Bearer ${token}`);
        },
      ],
      afterResponse: [
        async (req, _opts, res) => {
          if (res.status === 401 && !req.headers.get("x-retry")) {
            const newToken = await refreshTokens();
            if (newToken) {
              req.headers.set("Authorization", `Bearer ${newToken}`);
              req.headers.set("x-retry", "1");
              return ky(req);
            }
          }
          if (!res.ok && res.status >= 400 && res.status < 500 && res.status !== 401) {
            try { const text = describeApiError(await res.clone().json()); if (text) recordApiError(text); } catch { /* not JSON */ }
          }
          return res;
        },
      ],
    },
  });
  return _client;
}
